import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs';
import { AlertService } from 'src/app/services/common/alert.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  submittedUserPasswordForm = false;
  userPasswordForm: FormGroup;
  get f3() { return this.userPasswordForm.controls; }

  constructor(private formBuilderUserPassword: FormBuilder,
    private userService: UserService,
    private alertService: AlertService) { }

  ngOnInit() {
    this.buildForm();
  }

  buildForm(): void {
    this.userPasswordForm = this.formBuilderUserPassword.group({
      password: ['', [Validators.required]],
      newPassword: ['', [Validators.required]],
      rePassword: ['', [Validators.required]]
    }, {
      validators: this.passwordMatch.bind(this)
    });
  }

  passwordMatch(formGroup: FormGroup) {
    const password = formGroup.get('newPassword');
    const confirmPassword = formGroup.get('rePassword');

    const matchingControl = formGroup.controls['rePassword'];

    // return if another validator has already found an error on the matchingControl
    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      return;
    }

    // set error on matchingControl if validation fails
    if (password?.value === confirmPassword?.value) {
      matchingControl.setErrors(null);
    }
    else {
      matchingControl.setErrors({ mustMatch: true });
    }
  }

  onClickUserPasswordForm() {
    this.submittedUserPasswordForm = true;
    if (this.userPasswordForm.invalid)
      return;

    var model = Object.assign({});

    model.password = this.f3.password.value;
    model.newpassword = this.f3.newPassword.value;
    
    this.userService.profile_change_password(model).pipe(first()).subscribe({
      next: (response: any) => {
        if (response.success) {
          //this.alertService.showSuccess("Password update succesfully");
        }
      }
    });
  }
}
